/* Framework */
import $ from 'jquery';

/* Polyfill */
import 'picturefill';
import 'intersection-observer';

/* Class */
import agree from './class/agree';
import hamburger from './class/hamburger';
import loading from './class/loading';
import pagetop from './class/pagetop';
import pulldown from './class/pulldown';
import slidetoggle from './class/slidetoggle';
import smoothscroll from './class/smoothscroll';
import sticky from './class/sticky';
import delivery from './class/delivery';
import sectionCurrent from './class/sectionCurrent';

/* Module */
import marquee from './module/marquee';
import bgDarken from './module/bgDarken';
import tab from './module/tab';
import modal from './module/modal';
import loadMore from './module/loadMore';
import dropMenu from './module/dropMenu';
import newsFillter from './module/newsFillter';
import fileUpload from './module/fileUpload';
import formSelect from './module/formSelect';

/* Plugin */
// import anime from 'animejs/lib/anime.es.js';

;(function () {
  ////////////////////////////////////////////////////////// jQuery
  ;(function ($) {

    const $window = $(window);

    ////////////////////////////////////////////////////////// LOAD
    $window.on('load', onLoad);

    function onLoad() {
      /* 全体共通 */
      new hamburger();
      loading();
      pagetop();
      pulldown();
      smoothscroll();
      sticky();

      /* Slide Toggle専用 */
      if (document.getElementById('js-slideToggle') != null) {
        slidetoggle();
      }

      /* delivery専用 */
      if (document.getElementById('js-delivery') != null) {
        delivery();
      }

      /* Rest API Loading */
      if (document.getElementById('js-loadMore') != null) {
        loadMore();
      }

      /* Works Aページ専用 */
      if (document.getElementById('js-worksDetail') != null) {
        bgDarken();
        if (document.getElementById('js-marqueeCont') != null) {
          marquee();
        }
        tab();
        modal();
        new sectionCurrent();
      }

      /* drop menu */
      if (document.querySelector('.js-dropMenu') != null) {
        dropMenu();
      }

      /* News Fillter */
      if (document.querySelector('.js-newsFillter') != null) {
        newsFillter();
      }

      /* Formページ専用 */
      if (document.querySelector('.js-agree') != null) {
        new agree();
      }

      /* Formページ専用 */
      if (document.querySelector('.js-fileUpload') != null) {
        fileUpload();
      }

      /* Entryページ専用 */
      if (document.getElementById('mw_wp_form_mw-wp-form-385') != null) {
        formSelect();
      }
    }

  })(jQuery)

}());